// Endpoints configuration
// export const ENDPOINT: string = "http://69.169.101.31:5001/api/";
// export const WEB_URL: string = "http://69.169.101.31:5050/";
// export const IMAGEBASEURL: string = "http://69.169.101.31:5004/CLOUD_ITMMGT";


export const ENDPOINT: string = "https://api-core.eskaiy.dev/api/";
export const WEB_URL: string = "https://items.eskaiy.dev/";
export const IMAGEBASEURL: string = "https://fileserver.eskaiy.dev/CLOUD_ITMMGT";